var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 253,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m275.63 166.4-22.36-19.3-42.38-27.27-.42-.25-.35-.33-5.05-13.52 7.62-12.64-40.71 18.28 3.73 9.86 29.67 18.07 28.46 22.46-34.7 27.34-20.66 12.37-78.35 44.67 98.13 5.93 45.44-41.03 26.52-18.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m187.96 141.2-10.13-3.51-17.18-6.02-17.72-9.07-8.03-14.68 31.79-25.82 20.98-7.68L134.6 0l-25.28 63.37-30.78 11.34-8.1 22.24L0 116.38l30.29 54.6s23.62-.24 31.49 0c3.34.1 10.01.74 10.01.74l11.38 2.34 11.62 21.37s-.16 9.18-.66 12.64l12.44-6.84 94.23-34.48 11.59-6.32-24.42-19.21zm-82.97-32.73-18.52 2.54-3.55-2.64 4.41-8.8 3.53-2.59 15.32 8.31-1.19 3.19z"
  })));
};
export default SvgLogoWhite;